module.exports = __webpack_public_path__ + "img/ydybn_sample.a6908362.png";